export default __webpack_public_path__ + "static/media/envelope.829439f3.svg";